import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getTopIsco3Isco4ByCountry = async (HubIds: string[], fromQuarter?: string, toQuarter?: string) => {
    const { path, method } = endpoints.occupationAndSector.getTopIsco3Isco4ByCountry;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, fromQuarter, toQuarter },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
